import { getOrganisationUser } from '@infuse/api/iam/organisation';
import { getTenantUser } from '@infuse/api/iam/tenant';
import { getUser } from '@infuse/api/iam/user';
import { UserLevel } from '@infuse/iam/user/type';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { useGenericUser } from './generic/useGenericUser';

export const useUser = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.ORGANISATION) {
    return useGenericUser({
      apiFn: getOrganisationUser,
      queryKeys: ['users', 'organisation'],
      onlyEnableWithParentId: true,
      initialParentId: user?.organisationId
    });
  } else if (level === UserLevel.TENANT) {
    return useGenericUser({
      apiFn: getTenantUser,
      queryKeys: ['users', 'tenant'],
      onlyEnableWithParentId: true,
      initialParentId: user?.tenantId
    });
  }

  return useGenericUser({
    apiFn: getUser,
    queryKeys: ['users']
  });
};
